const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  goodsPreview ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/trade/refund/goods-preview', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  reasonList ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/trade/refund/reason-list', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  searchAliRefund ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/ali-dg/trade/refund/search-ali-refund', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  // uploadRefundVoucher ({ state, commit, rootState }, formData) {
  //   return rootState.axios.post('/magicbuy/v1backend/dgorder/refund/upload-refund-voucher', formData, {
  //     baseURL: 'https://apisp.jyb.com.tw',
  //     headers: {'Content-Type': 'multipart/form-data'},
  //   })
  // },
  // create ({ state, commit, rootState }, params) {
  //   return rootState.axios.post('/magicbuy/v1backend/dgorder/refund/create',
  //     params,
  //     {
  //       baseURL: 'https://apisp.jyb.com.tw',
  //     }
  //   )
  // },
  returnGoods ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/refund/return-goods',
      params,
      {
        baseURL: 'https://apisp.jyb.com.tw',
      }
    )
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
